import {PIXI} from '@colonist/pixi'
import {UIGameTimedAnimation} from './UIGameTimedAnimation'

interface ShakeAnimationOptions {
    shakeX: number
    shakeY: number
    frequency: number
    initialX: number
    initialY: number
}

export class UIGameShakeAnimation extends UIGameTimedAnimation {
    protected readonly forceEnableAnimation: boolean = true
    protected readonly options: ShakeAnimationOptions

    constructor(viewToAnimate: PIXI.Container, animationDuration: number = 500, options?: ShakeAnimationOptions) {
        super(animationDuration)
        this.viewToAnimate = viewToAnimate
        this.options = options ?? UIGameShakeAnimation.getDefaultOptions(viewToAnimate)
    }

    updateAnimation(deltaTime: number, elapsedMS: number) {
        const {shakeX, shakeY, frequency, initialX, initialY} = this.options
        const frequencyAbs = Math.abs(Math.round(frequency))
        const speedMultiplier = 4
        const progress = this.totalElapsedMS / 1000
        const offsetX = Math.sin(frequencyAbs * progress * Math.PI * speedMultiplier) * shakeX
        const offsetY = Math.cos(frequencyAbs * progress * Math.PI * speedMultiplier) * shakeY

        this.viewToAnimate.position.set(initialX + offsetX, initialY + offsetY)
    }

    resetToDefaultState(): void {
        this.viewToAnimate.position.set(this.options.initialX, this.options.initialY)
    }

    private static getDefaultOptions(viewToAnimate: PIXI.Container): ShakeAnimationOptions {
        return {
            shakeX: 5,
            shakeY: 0,
            frequency: 4,
            initialX: viewToAnimate.x,
            initialY: viewToAnimate.y,
        }
    }
}
